export const buildCartLineId = (itemId, selectedOptionIds) => {
  if (!selectedOptionIds?.length) return itemId;
  return `${itemId}::${[...selectedOptionIds].sort().join(',')}`;
};
